import { Skill } from '../creep-skill';

export const ENCOURAGE: Skill = {
  name: 'encourage',
  desk: `Remove all fatigue of the target creep. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks. Range 20 squares.`
} as Skill;

export const EXHAUST: Skill = {
  name: 'exhaust',
  desk: `Add
    <span><b>2</b>/<b>4</b>/<b>6</b>/<b>8</b>/<b>10</b></span> fatigue points to the target creep per each non-MOVE body part. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks. Range 20 squares.`
} as Skill;

export const DEFEND: Skill = {
  name: 'defend',
  desk: `Blocks up to
    <span><b>100</b>/<b>200</b>/<b>400</b>/<b>600</b>/<b>800</b></span> damage
     inflicted to the target creep on the next tick. Cooldown 5 ticks. Range 20 squares.`
} as Skill;

export const SUMMON: Skill = {
  name: 'summon',
  desk: `Instantly relocates your own creep in the same room to the square next to the power creep. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks.`
} as Skill;

export const SIGHT: Skill = {
  name: 'sight',
  desk: `Increase range of rangedAttack, rangedHeal, build, repair, or upgradeController of the target creep by 1 for the next 5 ticks. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks. Range 20 squares.`,
  requiresLevel: [20, 21, 22, 23, 24]
} as Skill;

export const RENEW: Skill = {
  name: 'renew',
  desk: `Adds time to live to the target creep and removes all its boosts. Consumes energy. The formula is the same as in StructureSpawn.renewCreep. Cooldown
    <span><b>5</b>/<b>4</b>/<b>3</b>/<b>2</b>/<b>1</b></span> ticks. Range 20 squares.`
} as Skill;

export const MASS_HEAL: Skill = {
  name: 'mass_heal',
  desk: `Heals all other creeps and power creeps in 3 squares range area for 2500/1000/250 hits depending on the range.
    Cooldown <span><b>25</b>/<b>20</b>/<b>15</b>/<b>10</b>/<b>5</b></span> ticks.`
} as Skill;

export const FOREMAN: Skill = {
  name: 'foreman',
  desk: `Increases effect of harvest, build, repair, and upgradeController of the target creep by 100%, and also increases energy consumption by 100%. Cooldown 50 ticks.
    Effect duration <span><b>30</b>/<b>60</b>/<b>90</b>/<b>120</b>/<b>150</b></span> ticks. Range 20 squares.`,
  requiresLevel: [10, 11, 12, 14, 22]
} as Skill;

export const RESURRECT: Skill = {
  name: 'resurrect',
  desk: `When targeted to a tombstone, returns a dead creep to life with the same time to live. The tombstone should contain all original resources. 
    The resurrected creep will have full hits. Cooldown
    <span><b>1000</b>/<b>900</b>/<b>800</b>/<b>700</b>/<b>600</b></span> ticks. Melee range.`,
  requiresLevel: [10, 11, 12, 14, 22]
} as Skill;

export const DISABLE: Skill = {
  name: 'disable',
  desk: `Disables all actions of the target creep on the next tick. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks. Melee range.`
} as Skill;

export const BERSERK: Skill = {
  name: 'berserk',
  desk: `Increase damage and heal inflicted by a creep by 100%, but also incoming damage and heal by 100%. Effect duration 5 ticks. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks. Range 20 squares.`,
  requiresLevel: [20, 21, 22, 23, 24]
} as Skill;


export const COMMANDER_SKILLS = [
  ENCOURAGE,
  EXHAUST,
  DEFEND,
  SUMMON,  
  RENEW,
  MASS_HEAL,
  DISABLE,
  FOREMAN,
  RESURRECT,
  SIGHT,  
  BERSERK
];



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/skills/skills.commander.ts